import Instafeed from 'instafeed.js';
import slick from "slick-carousel";

export const InstafeedController = () => {

    var feed = new Instafeed({
        get: 'user',
        userId: '13144499825',
        accessToken: '13144499825.1677ed0.35e4696d66c646a7a833ede924965c1f',
        template: '<a class="animation" href="{{link}}" target="_blank"><img src="{{image}}" /></a>',
        resolution: 'standard_resolution',
        limit: '10',
       
        after: function() {
            $('#instafeed').slick({
                infinite: true,
                centerMode: true,
                slidesToShow: 5,
                slidesToScroll: 5,

                responsive: [
                    {
                      breakpoint: 990,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    },
                  ]
            });   
        } 
    });
    feed.run();

    
   
      

}



// WEBPACK FOOTER //
// ./src/js/controllers/InstafeedController.js